import HNSColors from "../../../ui library/HNSColors";

export const STYLES = {
  menuDropdownButtonStyle: {
    backgroundColor: HNSColors.secondary[500],
    color: HNSColors.neutrals[900],
    fontWeight: "400",
    "&:hover": {
      backgroundColor: HNSColors.secondary[600],
      color: HNSColors.neutrals[900],
      fontWeight: "600",
    },
  },
  menuItemStyle: {
    "&:hover": {
      backgroundColor: HNSColors.tertiary[900],
      color: HNSColors.primary[500],
    },
    "&.Mui-selected": {
      backgroundColor: HNSColors.tertiary[900],
      color: HNSColors.primary[500],
    },
    "&.Mui-selected:hover": {
      backgroundColor: HNSColors.tertiary[900],
    },
  },

  menuListStyle: {
    width: "342px",
    border: "1px solid",
    borderRadius: "8px",
    borderColor: HNSColors.secondary[500],
    boxShadow: "none",
    marginTop: "2px",
  },
};
